export const apiRoutes = {
  getUser: '/users/me',
  getTokenByPassword: '/token/login-check',
  getRefreshToken: '/token/refresh',
  getReaction: '/api/reactions/:id',
  getReactions: '/api/reactions',
  getClientLoginAsUrl: '/clients/users/:id/impersonate',
  getContractorLoginAsUrl: '/contractors/:id/impersonate',
  sector: {
    get: '/branches/:id',
    update: '/branches/:id',
    create: '/branches',
  },
  sectors: {
    get: '/branches',
  },
  gigs: {
    accelerate: '/jobs/:id/accelerate',
    boost: '/jobs/:id/boost',
    getAll: '/jobs?',
    get: '/jobs/:id',
    reviews: '/jobs/:id/work-intents/list',
    matches: '/jobs/:id/matches/list',
    revertNoShow: '/commitments/:id/revert-no-show',
    resync: '/jobs/:id/reindex',
    getModelAgreement: '/jobs/modelagreement?jobId=:jobId&contractorId=:contractorId',
  },
  agencies: {
    getAll: '/agencies',
    get: '/agencies/:agencyId',
    createAgency: '/agencies',
    createAgencyUser: '/agencies/:agencyId/users',
    linkAgency: '/agencies/:agencyUuid/clients/:clientUuid/link',
    unlinkAgency: '/agencies/:agencyUuid/clients/:clientUuid/unlink',
    updateMaxHourlyWage: '/agencies/:agencyUuid/clients/:clientUuid/max-hourly-wage',
    getWorkers: '/agencies/:agencyId/workers',
    getClients: '/agencies/:agencyId/clients',
    getUsers: '/agencies/:agencyId/users',
  },
  contractor: {
    getAll: '/contractors?',
    getReports: '/contractors/:id/reports?sort=:sortOption',
    get: '/contractors/:id',
    getIDCheck: '/contractors/:id/id-check',
    getMatches: '/contractors/:id/matches?sort=:sortOption',
    verify: '/contractors/:id/verify',
    blocked: '/contractors/:id/toggle-ban',
    factoring: '/contractors/:id/factoring-discount',
    invoices: '/contractor/:id/invoices?sort=:sortOption',
    insights: 'contractors/:id/insights',
    notificationPreferences: '/contractors/:id/notifications',
    identityVerificationFailedInfo: '/contractors/identity-verification/:id/failed',
    reviews: {
      getAll: '/contractors/:id/reviews?sort=:sortOption',
      update: '/contractors/review/:id',
    },
    workIntents: {
      getAll: '/contractors/:id/work-intents?sort=:sortOption',
    },
    update: {
      personalInformation: '/contractors/:id/edit-personal',
      accountInformation: '/contractors/:id/edit-account',
      freelanceInformation: '/contractors/:id/edit-business',
    },
    workExperience: {
      getAll: '/contractors/:contractorId/work-experience',
      get: '/contractors/:contractorId/work-experience/:id',
      delete: '/contractors/work-experience/:id',
      update: '/contractors/work-experience/:id',
    },
  },
  skills: {
    getAll: '/skills?',
    create: '/skills',
    update: '/skills/:id',
    get: '/skills/:id',
    delete: '/skills/:id',
    merge: '/skills/merge',
  },
  function: {
    getAll: '/jobtitles',
    get: '/branches/jobtitles/:id',
    update: '/branches/jobtitles/:id',
    create: '/branches/jobtitles',
  },
  dressCode: {
    get: '/branches/dresscodes/:id',
    update: '/branches/dresscodes/:id',
    create: '/branches/dresscodes',
    sort: '/branches/dresscodes/sort',
  },
  declarations: {
    getAll: '/declaration/blocked?',
    update: '/declaration/:id/blocked',
  },
  mfa: {
    code: '/two-factor/login-check', // POST: validates 2FA code
    deregister: '/two-factor/deregister', // PATCH: deregisters 2FA
    register: '/two-factor/register', // GET: returns a qr code and a string fallback
  },
  modelAgreement: {
    get: '/model-agreements/:id',
    getAll: '/model-agreements',
    update: '/model-agreements/:id',
  },
  user: {
    getAll: '/users?',
    create: 'users',
    update: '/users/:id',
    updateMe: '/users/me',
    delete: '/users/:id',
    changeEmailRequest: '/users/change-email-request', // POST: sends email with token
    changeEmailTokenValidate: '/users/change-email', // POST: validates token and changes email
    changePassword: '/users/change-password',
    passwordReset: '/users/reset-password',
    passwordResetRequest: '/users/reset-password-request',
    passwordResetTokenValidate: '/users/reset-password-token-validation',
  },
  finance: {
    client: {
      discount: {
        create: '/finance/client/discount',
      },
      invoiceDetails: {
        get: '/finance/client/:id/invoice-details',
        post: '/finance/client/:id/invoice-details',
      },
    },
  },
  clients: {
    getAll: '/clients?',
    getAllShort: '/clients/short?',
    get: '/clients/:id',
    update: '/clients/:id',
    delete: '/clients/:id',
    block: '/clients/:id/block',
    onboarding: '/clients/onboarding/:id',
    unblock: '/clients/:id/unblock',
    financial: '/clients/financial/:id',
    invoices: '/clients/:clientUuid/invoices?sort=:sortOption',
    invoice: '/clients/:clientUuid/invoice/:invoiceNumber',
    updateInvoice: '/invoices/:invoiceNumber',
    downloadInvoice: '/clients/invoice/:invoiceNumber/pdf',
    reports: '/clients/:id/reports',
    blockedContractors: '/clients/:id/blocked-contractors?',
    verification: '/clients/:id/verification',
    crm: {
      get: '/clients/:id/crm',
      set: '/clients/:id/crm',
    },
    grants: {
      set: '/clients/:id/grants',
    },
    gigs: {
      get: '/clients/:id/jobs?',
    },
    chains: {
      get: '/clients/chain/:id',
      edit: '/clients/chain/:id',
      create: '/clients/chain',
      list: '/clients/chain?',
    },
    reviews: {
      get: '/clients/:id/reviews?',
      toggleVisibility: '/reviews/:id/toggle-visible',
      update: '/clients/review/:id',
    },
    users: {
      sendVerifyEmail: '/clients/users/:id/verify-email',
      update: {
        password: '/clients/users/:id/update-password',
      },
    },
    ubd: {
      resetDownload: '/clients/:id/ubd-file/re-enable',
    },
  },
  invoices: {
    download: '/invoices/:invoiceId/pdf',
  },
  queues: {
    getAll: '/queues',
    edit: '/queue-settings/:id',
    delete: '/queue-settings/:id',
    create: '/area-queues',
    contractor: {
      unQueue: '/contractors/:id/unqueue',
    },
    area: {
      getAll: '/areas',
    },
    queueSettings: '/queue/settings',
    settings: '/settings/queues',
  },
  commitments: {
    get: '/matches/:id',
    getSubstituteFlow: '/commitments/:id/substitute-flow',
  },
  chatgpt: {
    generate: '/api/chatGPTGenerateBoost',
  },
  dataProcessingAgreement: {
    upload: '/data-processing-agreements',
    getAll: '/data-processing-agreements',
    getDetails: '/data-processing-agreements/:id',
  },
};

export const pageRoutes = {
  main: '/',
  login: '/login',
  agencies: '/agencies',
  forgotPassword: '/forgot-password',
  mFACode: '/security/code',
  mFARecover: '/security/recovery',
  mFARegister: '/security/register',
  clients: '/clients',
  client: {
    details: '/clients/:id/details',
  },
  financial: '/financial',
  contractors: '/freelancers',
  freelancer: '/freelancers/:id/personal information',
  gigs: '/gigs',
  gigsID: '/gigs/:id',
  reactionsID: '/gigs/:id/reactions',
  matchesID: '/gigs/:id/matches',
  settings: '/settings',
  settingsUsers: '/settings/users',
  sectors: '/settings/sectors',
  modelAgreements: '/settings/model agreements',
  profile: '/profile',
};
